import { useMemo } from 'react';

import moment from 'moment';

import JanIcon from '@/shared/assets/icons/months/jan.svg?react';
import FebIcon from '@/shared/assets/icons/months/feb.svg?react';
import MarIcon from '@/shared/assets/icons/months/mar.svg?react';
import AprIcon from '@/shared/assets/icons/months/apr.svg?react';
import MayIcon from '@/shared/assets/icons/months/may.svg?react';
import JunIcon from '@/shared/assets/icons/months/jun.svg?react';
import JulIcon from '@/shared/assets/icons/months/jul.svg?react';
import AugIcon from '@/shared/assets/icons/months/aug.svg?react';
import SepIcon from '@/shared/assets/icons/months/sep.svg?react';
import OctIcon from '@/shared/assets/icons/months/oct.svg?react';
import NovIcon from '@/shared/assets/icons/months/nov.svg?react';
import DecIcon from '@/shared/assets/icons/months/dec.svg?react';

export const useGetCurrentMonthIcon = () => {
  const currentMonth = moment().format('MMMM');

  const MonthIcon = useMemo(() => {
    switch (currentMonth) {
      case 'January':
        return <JanIcon />;
      case 'February':
        return <FebIcon />;
      case 'March':
        return <MarIcon />;
      case 'April':
        return <AprIcon />;
      case 'May':
        return <MayIcon />;
      case 'June':
        return <JunIcon />;
      case 'July':
        return <JulIcon />;
      case 'August':
        return <AugIcon />;
      case 'September':
        return <SepIcon />;
      case 'October':
        return <OctIcon />;
      case 'November':
        return <NovIcon />;
      case 'December':
        return <DecIcon />;
    }
  }, [currentMonth]);

  return MonthIcon;
};
